module.exports = __webpack_public_path__ + "img/xiaotangshan.bee23053.png";